import { ReactNode } from 'react';
import ClipboardJS from 'clipboard';
import NextImage from '@/components/NextImage';
import { useGlobal } from '@/utils/useGlobal';
import EFWhatsApp from '@/components/UI/svg/blade/calculator/EFWhatsApp';

export default function Recommended() {
    const { useLang, Link, useRouter, gtm } = useGlobal();
    const { t } = useLang('bladecalculator');
    const { locale } = useRouter();
    // 配合data-clipboard-text使用，不能删
    const clipboard = new ClipboardJS('.recommended .result-btn.app');

    const getDataLayer = (button_name: string) => {
        return {
            event: 'uaEvent',
            event_name: 'checklist_interact_button',
            product_name: 'EcoFlow BLADE',
            list_name: 'Results_Recommended',
            button_name,
        };
    };

    const copyText = async () => {
        // if (navigator.clipboard && window.isSecureContext) {
        //     await navigator.clipboard.writeText('+1(626)271-0953');
        // } else {
        //     // Use the 'out of viewport hidden text area' trick
        //     const textArea = document.createElement('textarea');
        //     textArea.value = '+1(626)271-0953';

        //     // Move textarea out of the viewport so it's not visible
        //     textArea.style.position = 'absolute';
        //     textArea.style.left = '-999999px';

        //     document.body.prepend(textArea);
        //     textArea.select();

        //     try {
        //         document.execCommand('copy');
        //     } catch (error) {
        //         console.error(error);
        //     } finally {
        //         textArea.remove();
        //     }
        // }
        gtm.push({
            event: 'uaEvent',
            event_name: 'checklist_interact_button',
            product_name: 'EcoFlow BLADE',
            list_name: 'Results_Recommended',
            button_name: t('detail.calculator_result_card2_btn'),
        });
    };

    return (
        <div className="recommended result-box">
            <Link className="modal-close" href={'/blade-robotic-lawn-mower'}>
                &times;
            </Link>
            <div className="img-box">
                <NextImage
                    webpSrc={require('@publicLocal/blade/calculator/pc/result_recommended.webp')}
                    src={require('@publicLocal/blade/calculator/pc/result_recommended.png')}
                    alt={t('detail.calculator_result_card3_title')}
                    aria-label={t('detail.calculator_result_card3_title')}
                />
            </div>
            <p className="result-title">{t('detail.calculator_result_card3_title')}</p>
            <p className="result-text">{t('detail.calculator_result_card3_text')}</p>
            {/* TODO:  */}
            <Link
                className="result-btn"
                // href={['us', 'ca']?.includes(locale) ? '/blade-robotic-lawn-mower' : `https://${locale}.ecoflow.com/products/blade-robotic-lawn-mower`}
                // 0515 @陈琨 北美也要跳转shipofy
                href={`https://${locale}.ecoflow.com/products/blade-robotic-lawn-mower`}
                dataLayer={getDataLayer(t('detail.calculator_result_card3_btn'))}
            >
                {t('detail.calculator_result_card3_btn')}
            </Link>
            {/* 打开whatsapp聊天窗口 */}
            <a className="result-btn app" href={'whatsapp://send?phone=+1(626)271-0953&text=hello'} onClick={copyText} data-clipboard-text="+1(626)271-0953">
                {/* <a className="result-btn app" href={'https://api.whatsapp.com/send?phone=+1(626)271-0953'}> */}
                <span className="app-text">{t('detail.calculator_result_card2_btn')}</span>
                <span className="icon">
                    <EFWhatsApp />
                </span>
            </a>
            <p className="note">
                {t.rich('detail.calculator_result_card2_note', {
                    span: (child: ReactNode) => <span style={{ textDecoration: 'underline' }}>{child} </span>,
                })}
            </p>
        </div>
    );
}
